import Styles from './Text.module.scss'
import cx from 'classnames'
import { factory, Factory } from 'almanac-ui/factory'
import { filterDOMProps } from '@react-aria/utils'
import * as CSS from 'csstype'
import { HTMLAttributes, PropsWithChildren } from 'react'

export type TextVariant =
  | 'primary'
  | 'secondary'
  | 'placeholder'
  | 'label'
  | 'largeList'
  | 'smallList'
  | 'metadata'
  | 'largeListDark'
  | 'secondaryDark'

interface BaseTextProps extends Omit<HTMLAttributes<HTMLSpanElement>, 'color'> {
  variant?: TextVariant
  lineClamp?: number
  color?: string | null | false
  fontWeight?: string | null
}

export type TextProps = PropsWithChildren<BaseTextProps>

export type TextFactory = Factory<{
  props: TextProps
  ref: HTMLSpanElement
}>

export const Text = factory<TextFactory>(
  ({ variant = 'primary', children, lineClamp, color, fontWeight, ...otherProps }, ref) => {
    const style: CSS.Properties = {
      ['--lines-to-clamp' as any]: lineClamp,
      color: color || undefined,
      fontWeight: fontWeight || undefined,
    }

    return (
      <span
        className={cx(Styles.root, Styles[variant], {
          [Styles.lineClamp]: lineClamp !== 1,
          [Styles.lineClampForceSingleLine]: lineClamp === 1,
        })}
        {...filterDOMProps(otherProps, { labelable: true })}
        ref={ref}
        style={style}
      >
        {children}
      </span>
    )
  },
)
